import { render, staticRenderFns } from "./AccountSync.vue?vue&type=template&id=5be2ffda&scoped=true&"
import script from "./AccountSync.vue?vue&type=script&lang=js&"
export * from "./AccountSync.vue?vue&type=script&lang=js&"
import style0 from "./AccountSync.vue?vue&type=style&index=0&id=5be2ffda&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be2ffda",
  null
  
)

export default component.exports